export default {
  webApiSettings: {
    showCompaniesLogo: true,
    d4signRoute: 'https://secure.d4sign.com.br',
    buildConfiguration: process.env.BUILD_CONFIGURATION,
    apiServiceBaseUri: process.env.API_SERVICE_BASE_URI,
    viewerBaseUri: process.env.VIEWER_BASE_URI,
    viewerServer: process.env.VIEWER_SERVER,
    detailsCompany: process.env.DETAILS_COMPANY,
    urlWhitelist: process.env.URL_WHITE_LIST,
    ragIntegrationBaseUri: process.env.RAG_INTEGRATION_BASE_URI,
    onlyOfficeBaseUri: process.env.ONLY_OFFICE_BASE_URI
  },
};
